<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div class="mt-5" style="text-align: initial;"><span class="ml-3"><strong
                style="color: rgb(30, 70, 135);">{{ html.titulo }}</strong></span>
            <ul>
                <li v-for="(termino,index) in html.terminos" :key="index"> -{{ termino }}</li>
            </ul>
        </div>
    </div>
</template>
<script>

export default {
    name: "TerminosYCondiciones",
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        terminosYCondiciones: [],
        html: {},
    }),
    created(){
      this.debug = this.$localStorageService.getDebug();
        this.obtenerTerminosYCondiciones();
    },
    methods: {
        obtenerTerminosYCondiciones() {
            this.terminosYCondiciones = [];
            this.$http.post(this.$api + 'catalogos/terminosYCondiciones/obtenerTerminos').then(respuesta => {
                if(respuesta.data.data){
                    this.terminosYCondiciones = respuesta.data.data;
                    this.html = JSON.parse(this.terminosYCondiciones.html);
                }
            })
        },
    }

};
</script>